import { type PropsWithChildren } from "react";
import { RouterProvider } from "react-aria-components";
import { useNavigate, useRouter } from "@tanstack/react-router";

export const AriaRouteProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const navigate = useNavigate();

  return (
    <RouterProvider
      navigate={async (to) => {
        // Navigate to the provided path
        await navigate({ to });
      }}
      useHref={(to) => {
        // Build the href for the provided path
        return router.buildLocation({ to }).href;
      }}
    >
      {children}
    </RouterProvider>
  );
};
